import { render, staticRenderFns } from "./ThanksQuiz.vue?vue&type=template&id=458581ec&scoped=true&"
import script from "./ThanksQuiz.vue?vue&type=script&lang=js&"
export * from "./ThanksQuiz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458581ec",
  null
  
)

export default component.exports